import { LOCAL_STORAGE_KEYS } from "../constants/AppConstants";
const LocalUtils = {
  get(key) {
    if (typeof localStorage !== "undefined") {
      return localStorage.getItem(key);
    }
    return null;
  },

  set(key, value) {
    localStorage.setItem(key, value);
  },

  remove(key) {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
    sessionStorage.clear();
  },
  clearAuthenticationInfo() {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.CEO_INFO);
    sessionStorage.clear();
  },
};

export default LocalUtils;
